module.exports = __webpack_public_path__ + "img/jacob.8c87a240.png";